import {
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
  PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT,
  RolodexPermissions,
} from 'features/auth'

export const EDIT_MARKUP_LAYERS_PERMISSIONS_LIST: RolodexPermissions[] = [
  PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT,
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
]
